export default "__VITE_ASSET__DyRn2IxW__"